module.exports = "<h3>Verifying email...</h3>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/super_user/start/verify_email/verify-email.component.html
 ** module id = 272
 ** module chunks = 0
 **/